import React from 'react'
import { Redirect } from 'react-router-dom'
import { SEO } from '../../../components/Seo/seo'
import { FormattedMessage, useIntl } from 'react-intl'
import Layout from '../../../components/Dashboard/Layout/Layout'
import { NamedRoutes } from '../../../routes'
import { addPage } from '../../../utils/pages-meta.json'
import { AuthenticatedUserConsumer } from '../../../AuthenticatedUserContext'
import { PageProvider } from '../../../PageContext'
import { FormLoader } from '../../../components/Loader/FormLoader'
import PageEditContent from '../../../components/Dashboard/PageEditContent'


const SinglePageAdd = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'Pages.List.AddPage.Title' })}
           pathname={window.location.origin}
           titleTemplate={intl.formatMessage({ id: 'E-Tax' })}
           image={addPage.image}
           description={intl.formatMessage({ id: 'Pages.List.AddPage.Title' })}
      />
      <AuthenticatedUserConsumer>
        {({ userDataLoading, userData, handleNotificationCall, adminSectionType }) => (
          <>
            {!!userDataLoading && <FormLoader loading={true}/>}
            {!!Object.keys(userData).length &&
            <>
              {!!userData.is_admin ? <Layout content={
                <PageProvider pageAction={'add'} adminSectionType={adminSectionType}
                              handleNotificationCall={handleNotificationCall}>
                  <PageEditContent adminSectionType={adminSectionType} pageTitle={<FormattedMessage id='Pages.List.AddPage.Title'/>}/>
                </PageProvider>
              }/> : (!userDataLoading && <Redirect to={NamedRoutes.home}/>)
              }
            </>
            }
          </>
        )}
      </AuthenticatedUserConsumer>
    </>
  )
}

export default SinglePageAdd

